// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/elt-requirements.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/elt-requirements/elt-requirements.js';

mount([g0]);
